import LeadForm from './LeadForm';

export default function CTASection() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-6 sm:p-10 md:p-16 text-white text-center mb-10">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 md:mb-6">
            Сделайте развитие сотрудников управляемым
          </h2>
          <p className="text-sm md:text-base text-white/90 max-w-2xl mx-auto leading-relaxed mb-8">
            Если в компании есть сотрудники, которых необходимо развивать, готовить к новым ролям или включать в кадровый резерв, обсудим задачу и определим подходящий формат.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={() => document.getElementById('ipr-contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-teal-700 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Заказать разработку ИПР
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => document.getElementById('ipr-contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Получить пример ИПР
              <i className="ri-file-list-3-line"></i>
            </button>
          </div>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-5 sm:p-8 border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 text-center mb-6">Оставьте заявку</h3>
            <LeadForm formId="ipr-contact-form" source="individualnyy-plan-razvitiya-sotrudnikov" />
            <p className="text-xs text-gray-500 text-center mt-4">
              Отвечаю лично в течение одного рабочего дня.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}